import { graphql } from '@/gql';
import type { AssignLovedOneToCallerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const assignLovedOneToCaller = async ({
  callerId,
  lovedOneId,
  relationship,
}: AssignLovedOneToCallerMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AssignLovedOneToCaller($callerId: String!, $lovedOneId: String!, $relationship: String!) {
        assignLovedOneToCaller(callerId: $callerId, lovedOneId: $lovedOneId, relationship: $relationship) {
          id
        }
      }
    `),
    variables: {
      callerId,
      lovedOneId,
      relationship,
    },
  });

  return !!response.data?.assignLovedOneToCaller;
};
